/**
 * 文件类型判断工具
 *
 * 用于区分 plain 文件（UFS 裸文件）的类别：
 * - 文本类：可编辑，懒加载后存为 string
 * - 图片/PDF：只读预览，运行时 blob URL
 * - 其他二进制：不支持预览
 *
 * 依据 mime_type 优先，回退到文件扩展名
 */

const TEXT_MIME_PREFIXES = ['text/']
const TEXT_MIME_EXACT = new Set([
  'application/json',
  'application/xml',
  'application/javascript',
  'application/x-yaml',
  'application/x-sh',
  'application/sql',
])

const TEXT_EXTENSIONS = new Set([
  '.md', '.markdown', '.txt', '.text', '.csv', '.log',
  '.json', '.xml', '.yaml', '.yml',
  '.js', '.ts', '.jsx', '.tsx', '.mjs', '.cjs',
  '.py', '.rb', '.go', '.rs', '.java', '.kt', '.swift',
  '.c', '.h', '.cpp', '.hpp', '.cc',
  '.sh', '.bash', '.zsh', '.fish',
  '.sql', '.html', '.htm', '.css', '.scss', '.less',
  '.ini', '.toml', '.conf', '.env',
  '.svg',  // 文本类，可编辑
])

const IMAGE_MIME_PREFIX = 'image/'
const PDF_MIME = 'application/pdf'
const PDF_EXTENSION = '.pdf'

/** 获取文件扩展名（小写，含点） */
function getExtension(filename: string): string {
  const idx = filename.lastIndexOf('.')
  if (idx < 0) return ''
  return filename.slice(idx).toLowerCase()
}

/** 是否为文本类文件（可编辑） */
export function isTextFile(mime: string | null | undefined, filename: string): boolean {
  if (mime) {
    if (TEXT_MIME_PREFIXES.some(p => mime.startsWith(p))) return true
    if (TEXT_MIME_EXACT.has(mime)) return true
  }
  const ext = getExtension(filename)
  return TEXT_EXTENSIONS.has(ext)
}

/** 是否为图片文件 */
export function isImageFile(mime: string | null | undefined): boolean {
  return !!mime && mime.startsWith(IMAGE_MIME_PREFIX)
}

/** 是否为 PDF 文件 */
export function isPdfFile(mime: string | null | undefined, filename: string): boolean {
  if (mime === PDF_MIME) return true
  return getExtension(filename) === PDF_EXTENSION
}

/** 是否为可预览的二进制文件（图片或 PDF） */
export function isBinaryPreviewable(mime: string | null | undefined, filename: string): boolean {
  return isImageFile(mime) || isPdfFile(mime, filename)
}
